module.exports = __webpack_public_path__ + "img/ecology4.7df7decf.jpeg";